exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-4704180b] .el-input--mini .el-input__inner {\n  padding-left: 0;\n  font-size: 14px;\n  font-family: Roboto, serif;\n  height: 15px;\n  line-height: 28px;\n  border: none;\n  color: #3a3ace;\n}\nh2[data-v-4704180b] {\n  padding-bottom: 10px;\n}\n", ""]);

// exports
